// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"188df6fc","164":"d34fa7b9","190":"1ddde159","231":"c3e6519c","416":"ab830e46","617":"e575b7ae","744":"d8587471","791":"40cac04a","913":"33d12f92"}[chunkId] + ".chunk.js";
};